import { AxiosResponse } from 'axios';

import { HttpService } from '~system/api/base/http-service';

import { RequestParams } from '~app/types/api/requestParams';
import { getActiveScope } from '~app/utils/get-active-scope';

import {
  ApiLease,
  ApiLeaseCreate,
  ApiLeaseUpdate,
  ApiTenant,
} from '~shared/types';

const leasesUrlBuilder = (id = '') => {
  const scope = getActiveScope();
  const separator = id ? '/' : '';

  return `${scope}/leases${separator}${id}`;
};

export const getLeases = async (
  params?: RequestParams
): Promise<ApiLease[]> => {
  const requestUrl = leasesUrlBuilder();
  const { data }: AxiosResponse<ApiLease[]> = await HttpService.get(
    requestUrl,
    params
  );

  return data;
};

export const getLease = async (id: string) => {
  const requestUrl = leasesUrlBuilder(id);
  const { data }: AxiosResponse<ApiLease> = await HttpService.get(requestUrl);

  return data;
};

export const createLease = async (lease: ApiLeaseCreate) => {
  const requestUrl = leasesUrlBuilder();
  const { data }: AxiosResponse<ApiLease> = await HttpService.post(
    requestUrl,
    lease
  );

  return data;
};

export const updateLease = async (id: number, lease: ApiLeaseUpdate) => {
  const requestUrl = leasesUrlBuilder(`${id}`);
  const { data }: AxiosResponse<ApiLease> = await HttpService.patch(
    requestUrl,
    lease
  );

  return data;
};

export const deleteLease = async (id: number) => {
  const requestUrl = leasesUrlBuilder(`${id}`);
  const { data }: AxiosResponse = await HttpService.delete(requestUrl);

  return data;
};

export const getLeaseTenants = async (id: number) => {
  const requestUrl = leasesUrlBuilder(`${id}`);
  const { data }: AxiosResponse<ApiTenant[]> = await HttpService.get(
    `${requestUrl}/tenants`
  );

  return data;
};

export const getLeaseInviteInfo = async (code: string) => {
  const { data }: AxiosResponse<ApiLease> = await HttpService.get(
    `tenant/leases/invite-info/${code}`
  );

  return data;
};

export const respondLeaseInvitation = async (invitationResponse: {
  status: string;
  invite_code: string;
}) => {
  const { data }: AxiosResponse<ApiTenant> = await HttpService.post(
    `tenant/leases/respond-invitation`,
    invitationResponse
  );

  return data;
};

export const getTenantInviteLink = async (leaseId: string) => {
  const { data }: AxiosResponse<string> = await HttpService.get(
    `leases/${leaseId}/tenant-invite/link`
    // `leases/${leaseId}/tenant-invite/${tenantId}/link`
  );

  return data;
};
